import { WorkbenchService } from '@pique/core/modules/workbench';
import { useLiveData, useService } from '@toeverything/infra';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { showEdgelessToolsMenuAtom } from '../pique/setting-modal/atoms';
import { EdgelessToolsMenu } from './edgeless-tools-menu';

export const EdgelessViewToggle = memo(function EdgelessViewToggle() {
  const workbench = useService(WorkbenchService).workbench;
  const views = useLiveData(workbench.views$);
  const showToolsMenu = useAtomValue(showEdgelessToolsMenuAtom);

  const shouldShow =
    views.length >= 2 &&
    views.some(v => v.modeChange$.value === 'edgeless') &&
    showToolsMenu;

  if (!shouldShow) return null;

  return <EdgelessToolsMenu />;
});
